export default "__VITE_ASSET__CCk4YxIR__"